import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useAuthStore } from "../store/store";
//import { differenceInSeconds, intervalToDuration } from "date-fns";

//import { useAuthStore } from "../../../store/store";
//ThemeContext.Provider
/*const errorInfoStatus = useAuthStore.getState().errorInfoStatus;

const unsub1 = useAuthStore.subscribe(run);

function run(e) {
  //console.log(e.errorInfoStatus);
}*/

const baseURL =
  window.env?.VARS_BACKEND_URL ?? process.env.REACT_APP_SERVER_DOMAIN;

axios.defaults.baseURL = baseURL;
/** Make API Requests */

const DEBUG = process.env.NODE_ENV === "development";
// https://stackoverflow.com/questions/52737078/how-can-you-use-axios-interceptors
axios.interceptors.request.use(
  (config) => {
    /** In dev, intercepts request and logs it into console for dev */
    if (DEBUG) {
      console.info("✉️ ", config);
    }

    config.headers.genericKey = "someGenericValue";
    return config;
  },
  (error) => {
    if (DEBUG) {
      console.error("✉️ ", error);
    }
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  async (response) => {
    /*const token = await localStorage.getItem("token");
    if (token) {
      let decode = jwtDecode(token);
      let expireDateTime = new Date(decode.exp * 1000);

      const result = differenceInSeconds(expireDateTime, new Date());

      const interval = intervalToDuration({
        start: expireDateTime,
        end: new Date(),
      });

      console.log("");
    }

      if (error.code === axios.AxiosError.ERR_BAD_REQUEST &&
      error.status === 401 && error.response && error.response.data
    ) {
      useAuthStore.setState({ errorInfoStatus: error.response.data });
    }

    if (response.status === 401) {
      alert("You are not authorized");
    }*/
    console.log(response);
    return response;
  },
  (error) => {
    console.log("---HTTP response ERROR <<: " + error);
    if (error.code === axios.AxiosError.ERR_NETWORK) {
      //const updateAmount = useBookStore(state => state.updateAmount)
      //useDogStore.setState({ paw: false })
      useAuthStore.setState({ errorInfoStatus: "No hay conexión a internet" });
    }
    if (error.code === axios.AxiosError.ERR_BAD_REQUEST) {
      //const updateAmount = useBookStore(state => state.updateAmount)
      //useDogStore.setState({ paw: false })
      useAuthStore.setState({ errorInfoStatusData: error.response.data });
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    } else if (error) {
      return Promise.reject(error);
    }
    return Promise.reject(error.message);
  },
);

/** To get username from Token */
export async function getUsername() {
  const token = localStorage.getItem("token");
  if (!token) {
    useAuthStore.setState({ inLogoutMode: true });
    return Promise.reject("Cannot find token");
  }

  let decode = jwtDecode(token);
  //console.log(decode);
  const expiration = new Date(decode.exp * 1000);
  const now = new Date();
  //const fiveMinutes = 1000 * 60 * 5;
  // 540 min = 9 horas
  const sessionSpan = 1000 * 60 * 9;

  if (expiration.getTime() - now.getTime() < sessionSpan) {
    console.log("JWT has expired or will expire soon");

    useAuthStore.setState({ inLogoutMode: true });
  } else {
    console.log(`JWT is valid for more than ${sessionSpan} minutes`);
  }

  //
  return decode;
}

/** Authenticate user */
export async function authenthicate(username) {
  try {
    return await axios.post("/api/authenticate", { username });
  } catch (error) {
    return { error: "Username doesn't exist...!" };
  }
}

/** get User details */
export async function getUser({ username }) {
  try {
    const { data } = await axios.get(`/api/user/${username}`);
    return { data };
  } catch (error) {
    return { error: "Password doesn't Match...!" };
  }
}

/** register user function */
export async function registerUser(credentials) {
  try {
    const {
      data: { msg },
      status,
    } = await axios.post(`/api/register`, credentials);

    let { username, email } = credentials;

    /** send email */
    if (status === 201) {
      await axios.post("/api/registerMail", {
        username,
        userEmail: email,
        text: msg,
      });
    }

    return Promise.resolve(msg);
  } catch (error) {
    return Promise.reject({ error });
  }
}

/** login function */
export async function verifyPassword({ username, password }) {
  try {
    if (username) {
      const { data } = await axios.post("/api/login", { username, password });
      return Promise.resolve(data);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

/** update user profile function */
export async function updateUser(response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put("/api/updateuser", response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/** generate OTP */
export async function generateOTP(username) {
  try {
    const {
      data: { code },
      status,
    } = await axios.get("/api/generateOTP", { params: { username } });

    // send mail with OTP
    if (status === 201) {
      let {
        data: { email },
      } = await getUser({ username });
      let text = `Your Password Recovery OTP is ${code}. Verify and recover your password.`;
      await axios.post("/api/registerMail", {
        username,
        userEmail: email,
        text,
        subject: "Password recovery OTP.",
      });

      return Promise.resolve(code);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

/** verify OTP */
export async function verifyOTP({ username, code }) {
  try {
    const { data, status } = await axios.get("/api/verifyOTP", {
      params: { username, code },
    });
    return { data, status };
  } catch (error) {
    return Promise.reject(error);
  }
}

/** reset password */
/* TODO: REMOVE export async function resetPassword({ username, password }) {
  try {
    const { data, status } = await axios.put("/api/resetPassword", {
      username,
      password,
    });
    return Promise.resolve({ data, status });
  } catch (error) {
    return Promise.reject({ error });
  }
}
*/
/**
 NET core
 */

/** login function */
export async function login({ username, password }) {
  try {
    if (username) {
      const { data } = await axios.post("/api/Login", { username, password });
      /*
      let decode = jwtDecode(data.token);
      let expireDateTime = new Date(decode.exp * 1000);

      const result = differenceInSeconds(expireDateTime, new Date());

      const interval = intervalToDuration({
        start: expireDateTime,
        end: new Date(),
      });*/

      //format(new Date(2014, 1, 11), "MM/dd/yyyy");

      return Promise.resolve(data);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

/** update user profile function */
export async function usuarios() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Usuarios", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createUsuario(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Usuarios", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function usuario(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Usuarios/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchUsuario(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Usuarios/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateUsuario(userId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Usuarios/${userId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarUsuario(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Usuarios/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteUsuario(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/Usuarios/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function pendingResetPassword() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Usuarios/PendingResetPassword`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function startResetPassword(username) {
  try {
    const data = await axios.post(`/api/Usuarios/StartResetPassword`, {
      username,
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function approveResetPassword(username, approve) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      `/api/Usuarios/ApproveResetPassword`,
      { username, approve },
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function resetPassword(username, password) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      `/api/Usuarios/ResetPassword`,
      { username, password },
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Asociados
 */
export async function asociados() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Asociados", {
      headers: {
        Authorization: `${token}`,
      }, //, Accept: `text/plain` },
    });

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

export async function createAsociado(inputData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Asociados/", inputData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociado(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Asociados/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadoClientes(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Asociados/${userId}/Clientes`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchAsociados(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Asociados/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchCobranzaAsociados(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Asociados/SearchCobranza", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadoCobranzaDetalle(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/Asociados/AsociadoCobranzaDetalle",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadoCobranzaEstadoCuenta(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/Asociados/AsociadoEstadoCuenta",
      payload,
      {
        headers: { Authorization: `${token}` },
        responseType: "blob",
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchCobranzaAsociados2(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Asociados/SearchCobranza2", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateAsociado(userId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Asociados/${userId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarAsociado(asociadoId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Asociados/${asociadoId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function actualizarEmpleado(asociadoId, empleado) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Asociados/${asociadoId}/ActualizarEmpleado?empleado=${empleado}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteAsociado(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/Asociados/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateCreditoDispuestoAsociado(userId, credito) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Asociados/${userId}/ActualizarCreditoDispuesto?creditoDispuesto=${credito}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadosKPIDataIntegrity(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Asociados/KPIDataIntegrity", payload, {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Ciudades
 */
export async function ciudades() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Ciudades`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function regiones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Regiones`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function niveles() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Niveles`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function nivelesUsuarios() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/NivelesUsuarios`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function departamentos() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Departamentos`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}
/**
 Asociados
 */
export async function clientes() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Clientes", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchClientes(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Clientes/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchFastClientes(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Clientes/SearchFast", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createCliente(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Clientes", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

//--

/** register user function */
/*export async function registerUser(credentials) {
  try {
    const {
      data: { msg },
      status,
    } = await axios.post(`/api/register`, credentials);

    let { username, email } = credentials;

    /** send email /
    if (status === 201) {
      await axios.post("/api/registerMail", {
        username,
        userEmail: email,
        text: msg,
      });
    }

    return Promise.resolve(msg);
  } catch (error) {
    return Promise.reject({ error });
  }
}*/
//--

export async function cliente(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Clientes/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateCliente(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Clientes/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateClienteAgregarAsociado(userId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Clientes/${userId}/AgregarAsociado`,
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarCliente(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Clientes/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteCliente(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/Clientes/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function clientesKPIDataIntegrity(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Clientes/KPIDataIntegrity", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function clientesKPIDataIntegrityRanges(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/Clientes/KPIDataIntegrityRanges",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function clientesKPICompras(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Dashboards/ClientesCompras", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function configuraciones(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Configuraciones/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateConfiguraciones(payload) {
  /*
  {
  "nombre": "default",
  "horaInicial": "2024-11-16T23:47:25.990Z",
  "horaFinal": "2024-11-16T23:47:25.990Z"
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Configuraciones/1`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Notificaciones
 */
export async function notificaciones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Notificaciones", {
      headers: {
        Authorization: `${token}`,
      }, //, Accept: `text/plain` },
    });

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

/**
 NotificacionesDetalles
 */
export async function searchNotificaciones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Notificaciones/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 NotificacionesDetalles
 */
export async function notificacionesDetalles(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `api/NotificacionesDetalles/ByUsuario/${userId}`,
      {
        headers: {
          Authorization: `${token}`,
        }, //, Accept: `text/plain` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

export async function updateNotificacionDetalle(userId, visto = false) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `api/NotificacionesDetalles/${userId}/Visto?visto=${visto}`,
      null,
      {
        headers: { Authorization: `${token}` },
        "Content-Type": "multipart/form-data",
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Productos
 */
export async function productos() {
  try {
    //"{\"marcaIds\":[1],\"catalogoIds\":[],\"tipoProductoIds\":[],\"tagIds\":[],\"isActivo\":true,\"texto\":\"CE\"}"
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Productos", {
      headers: {
        Authorization: `${token}`,
      }, //, Accept: `text/plain` },
    });

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

export async function searchProductos(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Productos/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Paquetes
 */
export async function paquetes() {
  try {
    //"{\"marcaIds\":[1],\"catalogoIds\":[],\"tipoProductoIds\":[],\"tagIds\":[],\"isActivo\":true,\"texto\":\"CE\"}"
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Paquetes", {
      headers: {
        Authorization: `${token}`,
      }, //, Accept: `text/plain` },
    });

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

export async function searchPaquetes(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Paquetes/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createPaquete(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Paquetes", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updatePaquete(paqueteId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Paquetes/${paqueteId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 *
 * @param {images of type File} postData
 * @param {*} images
 * @returns
 */
export async function createProducto(postData, files) {
  const formData = new FormData();

  for (let index = 0; index < files.length; index++) {
    const file = files[index];

    formData.append("ProductName", Date.now().toString());
    formData.append(
      "ImageFiles" /*Date.now().toString()*/,
      file.file,
      file.file.name,
    );
  }

  const data = JSON.stringify(postData);

  formData.append(
    "JsonData",
    data,
    //`{ "Id": 123, "Nombre": "Dummy Description", "CreditoMinimo": 1234.33, "CreditoMaximo": 76.43, "Activo": true }`
    //`{ "name": "Dummy Name", "description": "Dummy Description" }`
  );

  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Productos", formData, {
      headers: { Authorization: `${token}` },
      "Content-Type": "multipart/form-data",
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

//
export async function pagoniTest(formData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/products", formData, {
      headers: { Authorization: `${token}` },
      "Content-Type": "multipart/form-data",
    });

    /*  let posi = await axios.post("/api/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });*/

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function pagoniTest22(formData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/products/32", formData, {
      headers: { Authorization: `${token}` },
      "Content-Type": "multipart/form-data",
    });

    /*  let posi = await axios.post("/api/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });*/

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}
//

export async function productoId(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Productos/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateProducto(productoId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Productos/${productoId}`, response, {
      headers: { Authorization: `${token}` },
      "Content-Type": "multipart/form-data",
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarProducto(productoId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Productos/${productoId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenVentaCancela(ordenId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${ordenId}/Cancelar`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenVentaDevolver(ordenId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${ordenId}/Devolver`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 roles
 */
///poner en combo en ussuarios, crar usuario/editar usuario guardar rolid
export async function roles() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Roles", {
      headers: {
        Authorization: `${token}`,
      }, //, Accept: `text/plain` },
    });

    return Promise.resolve(data);
  } catch (error) {
    console.log("---> " + error);
    return Promise.reject(error);
  }
}

/**
 * RolDetalles
 */
export async function rolesDetalles(rolId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/RolesDetalles/ByRolId/${rolId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Marcas
 */
export async function marcas() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Marcas`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchMarcas(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Marcas/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateMarca(marcaId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Marcas/${marcaId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createMarca(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Marcas", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarMarca(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Marcas/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 *
 * Asociados Solicitudes
 */
export async function asociadosSolicitudes() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/AsociadosSolicitudes`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadosSolicitudesCreate(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/AsociadosSolicitudes", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadosSolicitudesRevisar(solicitudId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/AsociadosSolicitudes/${solicitudId}/Revisar`,
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Tags
 */
export async function tags() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Tags", {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createTags(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Tags", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Generos
 */
export async function generos() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Generos", {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createGenero(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Generos", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchGeneros(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Generos/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateGenero(generoId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Generos/${generoId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarGenero(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Generos/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Tamaños
 */
export async function tamaños() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Tamaños", {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createTamaño(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Tamaños", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchTamaños(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Tamaños/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateTamaño(tamañoId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Tamaños/${tamañoId}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarTamaño(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Tamaños/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Concentraciones
 */
export async function concentraciones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Concentraciones", {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createConcentracion(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Concentraciones", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchConcentraciones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Concentraciones/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateConcentracion(concentracionId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Concentraciones/${concentracionId}`,
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarConcentracion(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Concentraciones/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Presentaciones
 */
export async function presentaciones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Presentaciones", {
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createPresentacion(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Presentaciones", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchPresentaciones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Presentaciones/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updatePresentacion(presentacionId, payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Presentaciones/${presentacionId}`,
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarPresentacion(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Presentaciones/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Proveedores
 */
export async function proveedores() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Proveedores", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchProveedores(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Proveedores/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createProveedor(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Proveedores", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function proveedor(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Proveedores/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateProveedor(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/Proveedores/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarProveedor(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/Proveedores/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteProveedor(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(
      `/api/Proveedores
      /${userId}`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

//--
//---
/**
 TiposEntrega
 */
export async function tiposEntrega() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/TiposEntrega", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchTiposEntrega(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/TiposEntrega/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createTiposEntrega(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/TiposEntrega", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function tipoEntrega(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/TiposEntrega/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateTiposEntrega(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/TiposEntrega/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarTiposEntrega(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/TiposEntrega/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteTiposEntrega(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/TiposEntrega/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 OrdenesVentas
 */
export async function ordenesVentas() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/OrdenesVentas", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchOrdenesVentas(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/OrdenesVentas/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchOrdenesVentasCSV(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/OrdenesVentas/SearchDownload",
      payload,
      {
        headers: { Authorization: `${token}`, ResponseType: "blob" },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createOrdenVenta(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/OrdenesVentas", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenVentas(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/OrdenesVentas/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateOrdenesVentas(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/OrdenesVentas/`, postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateOrdenVentaEstadoBodega(id, estadoBodegaId) {
  try {
    const info = { EstadoBodegaId: estadoBodegaId };
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${id}/EstadoBodega`,
      info,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateOrdenVentaEstatus(id, estatusOrdenId) {
  try {
    const info = { estatusOrdenId: estatusOrdenId };
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${id}/EstatusOrden`,
      info,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateOrdenVentaEstado(id, estadoOrdenId) {
  try {
    const info = { EstadoOrdenId: estadoOrdenId };
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/OrdenesVentas/${id}/EstadoOrden`, info, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateOrdenVentaEntregaForanea(
  id,
  entregaForaneaPayload,
) {
  try {
    const info = { entregasForaneas: [entregaForaneaPayload] };
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${id}/EntregaForanea`,
      info,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarOrdenesVentas(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/OrdenesVentas/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteOrdenesVentas(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/OrdenesVentas/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function demoParcialidades(payload) {
  try {
    const token = await localStorage.getItem("token");
    //const data = await axios.post("/api/OrdenesVentas", postData, {
    const data = await axios.post(
      `/api/OrdenesVentas/DemoParcialidades`,
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 EstatusOrden
 */
export async function estatusOrden() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/EstatusOrden", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchEstatusOrden(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstatusOrden/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createEstatusOrden(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstatusOrden", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function estatusOrdenOne(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/EstatusOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateEstatusOrden(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/EstatusOrden/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarEstatusOrden(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/EstatusOrden/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteEstatusOrden(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/EstatusOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 EstatusOrden
 */
export async function estatusOrden1() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/EstatusOrden", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchEstatusOrden1(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstatusOrden/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createEstatusOrden1(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstatusOrden", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function estatusOrdenOne1(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/EstatusOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateEstatusOrden1(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/EstatusOrden/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarEstatusOrden1(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/EstatusOrden/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteEstatusOrden1(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/EstatusOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 EstadosOrden
 */
export async function estadosOrden() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/EstadosOrden", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchEstadosOrden(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstadosOrden/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createEstatusOrden12(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstadosOrden", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function estadosOrden12z(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/EstadosOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateEstadosOrden(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/EstadosOrden/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarEstadosOrden(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/EstadosOrden/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteEstadosOrden(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/EstadosOrden/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 EstadosBodega
 */
export async function estadosBodega() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/EstadosBodega", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchEstadosBodega(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstadosBodega/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createEstadosBodega(postData) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/EstadosBodega", postData, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function estadosBodega4(userId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/EstadosBodega/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateEstadosBodega(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(`/api/EstadosBodega/${userId}`, response, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function activarEstadosBodega(userId, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/EstadosBodega/${userId}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteEstadosBodega(userId, response) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.delete(`/api/EstadosBodega/${userId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
 * HELPERS
 *https://stackoverflow.com/questions/44447847/enums-in-javascript-with-es6
 */
export function makeEnum(arr) {
  let obj = Object.create(null);
  for (let val of arr) {
    obj[val] = Symbol(val);
  }
  return Object.freeze(obj);
}

export function isFieldReadOnlyWith(createMode, text = null) {
  const { getState } = useAuthStore;
  /*  if (isAdmin == null) {
    const decodedToken = await getUsername();
    const roleId = decodedToken.rolId;
    const AdminRolId = 1;
    isAdmin = parseInt(roleId) === AdminRolId;
  }*/

  const states = getState();
  const isAdmin = states["isAdmin"];

  if (createMode) return false;
  if (isAdmin) return false;

  //const res = !createMode && text.length > 0;
  if (text == null) {
    return true;
  } else if (typeof text === "string" || typeof text === "object") {
    return text.length > 0;
  } else if (typeof text === "number") {
    //whatever
    return text > 0;
  }

  return true;
}

/**
 OrdenesComprasEspeciales
 */
export async function ordenesComprasEspeciales() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/OrdenesComprasEspeciales", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createOrdenesComprasEspeciales(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/OrdenesComprasEspeciales", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchOrdenesComprasEspeciales(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/OrdenesComprasEspeciales/Search",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenCompraEspecial(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/OrdenesComprasEspeciales/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenCompraEspecialUpdate(id, info) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/OrdenesComprasEspeciales/${id}`, info, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ordenCompraEspecialActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(
      `/api/OrdenesComprasEspeciales/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 CategoriasCompra
 */
export async function categoriasCompras() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/CategoriasCompra", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function categoriaCompraPost(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/CategoriasCompra", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function categoriaCompra(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/CategoriasCompra/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function categoriaCompraUpdate(id, info) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/CategoriasCompra/${id}`, info, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function categoriaCompraActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(
      `/api/CategoriasCompra/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 Bonificaciones
 */
export async function promociones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Promociones", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createBonificacion(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Bonificaciones", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchBonificaciones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Bonificaciones/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function bonificacion(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Bonificaciones/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function bonificacionesUpdate(id, info) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/Bonificaciones/${id}`, info, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function bonificacionActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");

    const data = await axios.put(
      `/api/Bonificaciones/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function promocionesConfigurar() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get("/api/Promociones/Configurar", {
      //headers: { Authorization: `${token}` },
      headers: {
        Authorization: `${token}`,
      },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updatePromocionesConfigurar(payload) {
  try {
    /*
    {
  "fecha": "2025-09-04T06:08:40.840Z",
  "meta": 0
}
  */
    const token = await localStorage.getItem("token");

    const data = await axios.put(
      `/api/Promociones/Configurar`,
      { promociones: payload },
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*

*/

export async function dashboardVentasPorPeriodo(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/Dashboards/VentasPorPeriodo", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function dashboardVentasPorPeriodoComparativa(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "api/Dashboards/VentasPorPeriodoComparativa",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function dashboardVentasPorPeriodoComparativaTarjetas(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "api/Dashboards/VentasPorPeriodoComparativaTarjetas",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function dashboardVentasAsociadoPorDia(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "api/Dashboard/VentasAsociadoPorDia",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function dashboardAsociadosNuevos(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/Dashboards/AsociadosNuevos", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function dashboardClientesNuevos(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/Dashboards/ClientesNuevos", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
MetasVentasDiaria
*/
export async function MetasVentasDiaria() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasDiaria`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createMetasVentasDiaria(payload) {
  /*
  {
  "fecha": "2025-09-04T05:56:29.705Z",
  "meta": 0
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/MetasVentasDiaria", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasDiariaById(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasDiaria/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateMetasVentasDiariaById(id, payload) {
  try {
    /*
    {
  "fecha": "2025-09-04T06:08:40.840Z",
  "meta": 0
}
  */
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/MetasVentasDiaria/${id}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getMonthMetasVentasDiaria(fecha) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `/api/MetasVentasDiaria/PorFecha?fecha=${fecha}`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function metaVentaDia(fecha) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `/api/MetasVentasDiaria/PorFechaEspecifica?fecha=${fecha}`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createMonthMetasVentasDiaria(payload) {
  /*
  {
  "metaVentasDiarias": [
    {
      "fecha": "2025-08-04T05:51:49.278Z",
      "meta": 0
    }
  ]
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "api/MetasVentasDiaria/MetasVentasDiarias",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasDiariaActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/MetasVentasDiaria/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
MetasVentasMensual
*/
export async function MetasVentasMensual() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasMensual`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createMetasVentasMensual(payload) {
  /*
  {
  "fecha": "2025-09-04T05:56:29.705Z",
  "meta": 0
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/MetasVentasMensual", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasMensualById(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasMensual/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateMetasVentasMensualById(id, payload) {
  try {
    /*
    {
  "fecha": "2025-09-04T06:08:40.840Z",
  "meta": 0
}
  */
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/MetasVentasMensual/${id}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getMonthMetasVentasMonth(fecha) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `/api/MetasVentasMensual/PorFecha?fecha=${fecha}`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasMensualActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/MetasVentasMensual/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
MetasVentasNivel
*/
export async function MetasVentasNivel() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasNivel`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function create1MetasVentasNivel(payload) {
  /*
  
  "fecha": "2025-09-04T06:28:30.188Z",
  "meta": 0,
  "nivelId": 0
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("api/MetasVentasNivel", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasNivelById(id) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`api/MetasVentasNivel/${id}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateMetasVentasNivelById(id, payload) {
  try {
    /*
    {
  "fecha": "2025-09-04T06:08:40.840Z",
  "meta": 0
}
  */
    const token = await localStorage.getItem("token");

    const data = await axios.put(`/api/MetasVentasNivel/${id}`, payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getMetasVentasNivel(fecha) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `/api/MetasVentasNivel/PorFecha?fecha=${fecha}`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createMetasVentasNivel(payload) {
  /*
  {
  "metaVentasNiveles": [
    {
      "fecha": "2025-09-04T06:31:57.692Z",
      "meta": 0,
      "nivelId": 0
    }
  ]
}
  */
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "api/MetasVentasNivel/MetasVentasNiveles",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function MetasVentasNivelActivar(id, activo) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.put(
      `/api/MetasVentasNivel/${id}/Activar?activo=${activo}`,
      null,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function printTicket(payload) {
  try {
    //const token = await localStorage.getItem("token");
    const data = await axios.post("http://localhost:4000/", payload, {
      headers: { "Content-type": "application/json" },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function generateTicketPDF(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/OrdenesVentas/GenerarTicketPDF",
      payload,
      {
        headers: { Authorization: `${token}` },
        responseType: "blob",
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getFormasDePago() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/FormasDePago/`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function pagos() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Pagos`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function pagoById(pagoId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Pagos/${pagoId}`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function pagosByAsociadoId(asociadoId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Pagos/${asociadoId}/Asociado`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createPago(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Pagos/Create", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createSubPago(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Pagos/CreateSubPago", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function asociadoProrrateo(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Pagos/ProrrateoAsociado", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function clienteProrrateo(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Pagos/ProrrateoCliente", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function parcialidadHistorialLast() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/ParcialidadHistorial/last`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function VentasPorProducto(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post(
      "/api/Dashboards/VentasPorProducto",
      payload,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function VentasPorGenero(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Dashboards/VentasPorGenero", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function VentasPorMarca(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Dashboards/VentasPorMarca", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function distribucionPagosByAsociadoId(asociadoId) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(
      `/api/DistribucionPagos/${asociadoId}/Asociado`,
      {
        headers: { Authorization: `${token}` },
      },
    );

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function undoProrrateo(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/DistribucionPagos/Undo", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function comisiones() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/Comisiones`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function searchComisiones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Comisiones/Search", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function createComisiones(payload) {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.post("/api/Comisiones", payload, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function formasDePago() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/FormasDePago`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function metodosDePago() {
  try {
    const token = await localStorage.getItem("token");
    const data = await axios.get(`/api/MetodosDePago`, {
      headers: { Authorization: `${token}` },
    });

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}
